import type { IconProps } from '@/types/general'

export const ChevronDown = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="currentColor"
    className={props.className}
  >
    <path
      d="M17.3274 5.74699L9.9999 13.0745L2.6724 5.74699C2.34698 5.42158 1.81948 5.42158 1.49406 5.74699C1.16865 6.07241 1.16865 6.59991 1.49406 6.92533L9.41073 14.842C9.57365 15.0049 9.78656 15.0862 9.9999 15.0862C10.2132 15.0862 10.4261 15.0049 10.5891 14.842L18.5057 6.92533C18.8311 6.59991 18.8311 6.07241 18.5057 5.74699C18.1803 5.42158 17.6528 5.42158 17.3274 5.74699Z"
      fill="currentColor"
    />
  </svg>
)
